import { Component } from '@angular/core';
import { Constants } from '../Helpers/constants';
import { LoginCustomisation } from '../interfaces';
import { SharedService } from '../shared.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'layout-background',
  templateUrl: './background.component.html'
})
export class BackgroundComponent {
  public bgSrcUrl: any;
  public backgrounImagePath: any;
  public backgroundGradient: any;
  private loginCustomisation: LoginCustomisation;
  private readonly backgroundImageFromRoute: string

  constructor(
    public sharedService: SharedService,
    private activatedRoute: ActivatedRoute
  ) {
    this.backgroundImageFromRoute = this.activatedRoute.snapshot.data['backgroudImage'];
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        this.loginCustomisation = this.sharedService.loginCustomisation.value;
        this.loadCustomisation()
        if (this.sharedService.BackgroundImage.value != null) {
          this.bgSrcUrl = this.sharedService.BackgroundImage.value;
        } else {
          this.bgSrcUrl = '../../../assets/img/able/able-homepage-bg-cropped.png';
        }
      } else {
        this.bgSrcUrl = '../../../assets/img/able/able-homepage-bg-cropped.png';
      }
    } else if (this.backgrounImagePath) {
      this.bgSrcUrl = this.backgroundImageFromRoute ? this.backgroundImageFromRoute : '../../../assets/img/able/able-homepage-bg-cropped.png';
    }
     else {
      this.bgSrcUrl = this.sharedService.currentOrganisationId.value == Constants.ulsterOrganisationId ? '../../../assets/img/ulster/ulster-background.png' : this.sharedService.currentOrganisationId.value == Constants.lululemonOrganisationId ? '../../../assets/img/lululemon/background-c3.png' : '../../../assets/img/able/able-homepage-bg-cropped.png';
    }
    if (this.sharedService.BackgroundImage.value != null) {
      this.bgSrcUrl = this.sharedService.BackgroundImage.value;
    }
  }

  private loadCustomisation() {
    if (this.loginCustomisation != null) {
      if (this.loginCustomisation.backColor1 != null && this.loginCustomisation.backColor2 != null) {
        this.bgSrcUrl = undefined;
        let gradientDirection: any = '';
        if (this.loginCustomisation.gradientDirection != null && this.loginCustomisation.gradientDirection.toString().trim().length > 0) {
          gradientDirection = this.loginCustomisation.gradientDirection;
        } else {
          gradientDirection = 'linear-gradient';
        }
        this.backgroundGradient = gradientDirection + '(to bottom right,' + this.loginCustomisation.backColor1 + ',' + this.loginCustomisation.backColor2 + ')'
      } else {
        this.backgroundGradient = undefined;
        this.backgrounImagePath = undefined;
        this.bgSrcUrl = '../../../assets/img/able/able-homepage-bg-cropped.png';
      }
    }
  }
}
